import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

function NotFound() {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Aradığınız Sayfa Bulunamadı</h2>
        <p>Üzgünüz, istediğiniz sayfa mevcut değil veya taşınmış olabilir.</p>
        <Link to="/" className="not-found-back-link">Ana Sayfaya Dön</Link>
      </div>
    </div>
  );
}

export default NotFound;